import * as React from 'react'
import { FC } from 'react'
import { graphql } from 'gatsby'
import Layout from '../../components/Layout/Layout'
import Section from '../../components/Section/Section'
import SimpleMarkdown from '../../components/SimpleMarkdown/SimpleMarkdown'
import { cls } from '../../utils/utils'
import { ITags } from '../../components/Tags/Tags.types'
import Tags from '../../components/Tags/Tags'
import Video, { IVideoProps } from '../../components/Widgets/Video/Video'
import Sources, { ISource } from './components/Sources'
import * as styles from './PressDetails.module.scss'

interface IPressDetailsProps {
  data: {
    markdownRemark: {
      frontmatter: {
        title: string
        date: string
        tags?: ITags
        sources?: ISource[]
      }
      html: string
    }
  }
}

const PressDetails: FC<IPressDetailsProps> = ({ data }) => {
  const { frontmatter, html } = data.markdownRemark
  return (
    <Layout title={frontmatter.title}>
      <PressDetailsTemplate {...frontmatter} body={html} />
    </Layout>
  )
}

interface IPressDetailsTemplateProps {
  title: string
  date: string
  tags?: ITags
  sources?: ISource[]
  video?: IVideoProps
  body: string
}

export const PressDetailsTemplate: FC<IPressDetailsTemplateProps> = ({ title, date, sources, body, tags, video }) => (
  <Section backgroundColor="white" rectanglesColor="black" dontShowParallelepiped hideBottomPadding>
    <div className={styles.container}>
      <div className="main-container grid-12">
        <div className={styles.columns_3_11}>
          <h1 className={styles.header}>{title}</h1>
          {tags && <Tags tags={tags} />}
          <p className={cls('text--caption', styles.date)}>{date}</p>
          {video && <Video source={video.source} />}
          <SimpleMarkdown body={body} className={cls('text--large', styles.content)} />
          <Sources className={styles.content} sources={sources} />
        </div>
      </div>
    </div>
  </Section>
)

export const pageQuery = graphql`
  query pressDetails($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        date(formatString: "MMMM Do, YYYY", locale: "en-US")
        tags
        video {
          source
        }
        sources {
          source
          link
        }
      }
      html
    }
  }
`

export default PressDetails
